import { get, writable } from "svelte/store";

const Hotkeys = {
	_initted: false,
	_idCounter: 1,
	data: writable([]),
	init: () => {
		document.addEventListener("keydown", (e) => {
			const elementType = document.activeElement.nodeName.toLowerCase();
			if (elementType === "input" || elementType === "textarea") {
				return;
			}
			let ran = false;
			const hotkeyData = get(Hotkeys.data);
			for (let i = 0; i < hotkeyData.length; i++) {
				const hotkey = hotkeyData[i];
				for (const key in hotkey.data) {
					if (key === "event") {
						continue;
					}
					if (hotkey.data[key] === e[key] && hotkey.data.event) {
						hotkey.data.event(e);
						ran = true;
					}
				}
			}
			if (ran) {
				e.preventDefault();
			}
		});
		Hotkeys._initted = true;
	},
	create: (data) => {
		if (!Hotkeys._initted) {
			Hotkeys.init();
		}
		const hotkey = {
			_id: Hotkeys._idCounter++,
			data: data
		};
		Hotkeys.data.update((data) => {
			return [...data, hotkey];
		});
		return hotkey;
	},
	removeAll: () => {
		Hotkeys.data.set([]);
	},
	remove: (data, limit = -1) => {
		if (!data._id) {
			data = { _id: -1, data: data };
		}
		let countRemoved = 0;
		const hotkeysData = get(Hotkeys.data);
		for (let i = 0; i < hotkeysData.length; i++) {
			const hotkey = hotkeysData[i];
			if (Hotkeys._equals(data, hotkey)) {
				Hotkeys.data.update((data) => {
					data.splice(i, 1);
					return data;
				});
				// Hotkeys._data.splice(i, 1);
				i--;

				// Ensure we only delete the number that we specify.
				if (limit >= 1) {
					countRemoved++;
					if (countRemoved >= limit) {
						break;
					}
				}
			}
		}
	},
	count: () => {
		return get(Hotkeys.data).length;
	},
	_equals: (item1, item2) => {
		// Item2 must be the one that is stored internally.

		// Check whether they're literally the same object.
		if (item1._id === item2._id) {
			return true;
		}
		// Item2 must satisfy ALL properties of Item1 to be equal.
		for (const key1 in item1.data) {
			if (item1.data[key1] !== item2.data[key1]) {
				return false;
			}
		}
		return true;
	}
};
export default Hotkeys;
